module.exports = __webpack_public_path__ + "static/media/004-flash.8867eaa8.svg";